import React from 'react';
import { useNavigate } from 'react-router-dom';

const legacyRoutes = {
  '#/privacy': '/apps/daily-horoscope/privacy',
  '#/terms': '/apps/daily-horoscope/terms',
};

export function LegacyHashRouteBridge() {
  const navigate = useNavigate();

  React.useEffect(() => {
    const openLegacyRoute = () => {
      const destination = legacyRoutes[window.location.hash];
      if (destination) {
        navigate(destination, { replace: true });
      }
    };

    openLegacyRoute();
    window.addEventListener('hashchange', openLegacyRoute);
    return () => window.removeEventListener('hashchange', openLegacyRoute);
  }, [navigate]);

  return null;
}
